<template lang="html">
  <div class="page-section">
    <div class="list-pricing">
      <div class="container">
        <h2 class="list-title" v-if="title" v-html="title"></h2>

        <div class="tiers">
          <div
            class="pricing-tier content-bg"
            v-for="(item, index) in items"
            :key="`pricing-tier-${index}`"
          >
            <h2
              class="column-title"
              @click="highlightField('column title')">
              {{ parse(item).column_title }}
            </h2>

            <div
              class="price-info"
              :style="{background: parse(item).colour}"
              @click.self="highlightField('colour')">

              <h3 class="currency-symbol" @click="highlightField('currency symbol')">
                {{ parse(item).currency_symbol }}
              </h3>

              <h3 class="price" @click="highlightField('price')">
                {{ parse(item).price }}
              </h3>

              <h3 class="time-period" @click="highlightField('time period')">
                {{ parse(item).time_period }}
              </h3>
            </div>

            <ul>
              <li v-if="parse(item).feature_1" @click="highlightField('feature 1')">
                {{ parse(item).feature_1 }}
              </li>
              <li v-if="parse(item).feature_2" @click="highlightField('feature 2')">
                {{ parse(item).feature_2 }}
              </li>
              <li v-if="parse(item).feature_3" @click="highlightField('feature 3')">
                {{ parse(item).feature_3 }}
              </li>
              <li v-if="parse(item).feature_4" @click="highlightField('feature 4')">
                {{ parse(item).feature_4 }}
              </li>
              <li v-if="parse(item).feature_5" @click="highlightField('feature 5')">
                {{ parse(item).feature_5 }}
              </li>
              <li v-if="parse(item).feature_6" @click="highlightField('feature 6')">
                {{ parse(item).feature_6 }}
              </li>
              <li v-if="parse(item).feature_7" @click="highlightField('feature 7')">
                {{ parse(item).feature_7 }}
              </li>
              <li v-if="parse(item).feature_8" @click="highlightField('feature 8')">
                {{ parse(item).feature_8 }}
              </li>
            </ul>

            <div class="tier-button">
              <a
                class="btn is-dark"
                v-if="parse(item).button_text"
                :title="`Will link to: ${parse(item).button_link}`"
                @click="highlightField('button link')">
                {{ parse(item).button_text }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

export default {
  name: 'PricingTable',

  mixins: [parseComponent],

  props: {
    title: String,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'
@import '../../stylesheets/base/theme'

.list-pricing
  .list-title
    margin-bottom: $gap-medium

  .tiers
    @include media($media-gt-medium)
      display: flex
      align-items: center
      justify-content: center
      flex-wrap: wrap

  .price-info
    display: flex
    align-items: center
    justify-content: center
    border-bottom: 1px solid
    border-top-left-radius: 5px
    border-top-right-radius: 5px

    @include themify($themes)
      border-color: themed('border-color')

    .currency-symbol, .time-period
      font-size: 18px

    .price
      font-size: 36px
      margin: 0 4px 0 2px

  .tiers
    ul
      padding: 0
      list-style: none

    li
      margin-bottom: $gap-x-small
      padding: $gap-medium
      background: rgba(0, 0, 0, 0.05)
      border-radius: 5px

  .pricing-tier
    padding: $gap-medium
    margin: $gap-small
    flex-basis: calc(#{percentage(1/3)} - #{$gap-small}*2)
    background: #fff
    box-shadow: 0 0 90px rgba(0,0,0,.25)

    @include themify($themes)
      color: themed('text')

  .tier-button, .column-title
    text-align: center

  .column-title
    margin-bottom: $gap-small
    margin-top: 0
</style>
